import { render, staticRenderFns } from "./RuleEditView.vue?vue&type=template&id=11947206&scoped=true"
import script from "./RuleEditView.vue?vue&type=script&lang=js"
export * from "./RuleEditView.vue?vue&type=script&lang=js"
import style0 from "./RuleEditView.vue?vue&type=style&index=0&id=11947206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11947206",
  null
  
)

export default component.exports